import { NameErrors } from '../../../../../shared/errors/error-messages';
import { RadioOption } from './invoices-my.models';

export enum ControlName {
  // EW Info
  ewInfo = 'ewInfo',
  IntDocNumber = 'IntDocNumber',
  ScanSheet = 'ScanSheet',
  Printed = 'Printed',
  InfoRegClientBarcodes = 'InfoRegClientBarcodes',
  Weight = 'Weight',
  WeightFrom = 'WeightFrom',
  WeightTo = 'WeightTo',
  SeatsAmount = 'SeatsAmount',
  SeatsAmountFrom = 'SeatsAmountFrom',
  SeatsAmountTo = 'SeatsAmountTo',
  creationDate = 'creationDate',
  CreationDateTimeFrom = 'CreationDateTimeFrom',
  CreationDateTimeTo = 'CreationDateTimeTo',
  DeliveryDate = 'DeliveryDate',
  DeliveryDateTimeFrom = 'DeliveryDateTimeFrom',
  DeliveryDateTimeTo = 'DeliveryDateTimeTo',
  sendDate = 'sendDate',
  DateTimeFrom = 'DateTimeFrom',
  DateTimeTo = 'DateTimeTo',
  PreferredDeliveryDate = 'PreferredDeliveryDate',
  // Payment Info
  paymentInfo = 'paymentInfo',
  Cost = 'Cost',
  CostFrom = 'CostFrom',
  CostTo = 'CostTo',
  BackwardDeliveryMoney = 'BackwardDeliveryMoney',
  Afterpayment = 'Afterpayment',
  CostOnSite = 'CostOnSite',
  CostOnSiteFrom = 'CostOnSiteFrom',
  CostOnSiteTo = 'CostOnSiteTo',
  PayerType = 'PayerType',
  SelectPaymentOnSitePayed = 'SelectPaymentOnSitePayed',
  // Sender Info
  senderInfo = 'senderInfo',
  SenderRef = 'SenderRef',
  SenderContactPerson = 'SenderContactPerson',
  SenderContactPhone = 'SenderContactPhone',
  SettlementSender = 'SettlementSender',
  DeliveryFrom = 'DeliveryFrom',
  SenderWarehouse = 'SenderWarehouse',
  // Recipient Info
  recipientInfo = 'recipientInfo',
  RecipientRef = 'RecipientRef',
  RecipientEDRPOU = 'RecipientEDRPOU',
  RecipientContactPhone = 'RecipientContactPhone',
  SettlementRecipient = 'SettlementRecipient',
  DeliveryTo = 'DeliveryTo',
  RecipientWarehouse = 'RecipientWarehouse',
  // Additional Services
  additionalServices = 'additionalServices',
  BackwardDeliveryDocuments = 'BackwardDeliveryDocuments',
  Packing = 'Packing',
  FloorsLifting = 'FloorsLifting',
  SameDayDelivery = 'SameDayDelivery',
  SubtypeDocuments = 'SubtypeDocuments',
  SignedDocuments = 'SignedDocuments',
  Forwarding = 'Forwarding',
}

export enum AdditionalServicesLabels {
  BackwardDeliveryDocuments = 'Зворотна доставка документів',
  Packing = 'Замовлено пакування',
  FloorsLifting = 'До дверей',
  SameDayDelivery = 'Локал Експрес',
  SubtypeDocuments = 'Зворотна доставка підтипів документів',
  SignedDocuments = 'Зворотна доставка підписаних документів',
  Forwarding = 'Контроль поштучної передачі',
}

export enum DeliverySite {
  Postomat = 'Postomat',
  Warehouse = 'Warehouse',
}

export enum ChipsPaymentState {
  Paid = 'Сплачено',
  NotPaid = 'Не сплачено',
}

export enum ChipsRegisterState {
  In = 'В реєстрі',
  NotIn = 'Не в реєстрі',
}

export enum ChipsPrintedState {
  Printed = 'Роздруковані',
  NotPrinted = 'Нероздруковані',
}

export enum ChipsBackwardDeliveryMoneyState {
  With = 'З післяплатою',
  Without = 'Без післяплати',
}

export enum ChipsAfterpaymentState {
  With = 'З контролем оплати',
  Without = 'Без контролю оплати',
}

export enum SenderWarehouseTooltip {
  NoCity = 'Спочатку оберіть місто відправлення',
  NoWarehouses = 'Немає відділень в обраному населеному пункті',
}

export enum SenderPostMatTooltip {
  NoCity = 'Спочатку оберіть місто відправлення',
  NoWarehouses = 'Немає поштоматів в обраному населеному пункті',
}

export enum RecipientWarehouseTooltip {
  NoCity = 'Спочатку оберіть місто отримання',
  NoWarehouses = 'Немає відділень в обраному населеному пункті',
}

export enum RecipientPostMatTooltip {
  NoCity = 'Спочатку оберіть місто отримання',
  NoWarehouses = 'Немає поштоматів в обраному населеному пункті',
}

export const senderRefSearchResultKeys = [
  'City',
  'CityDescription',
  'Counterparty',
  'CounterpartyFullName',
  'CounterpartyType',
  'Description',
  'EDRPOU',
  'FirstName',
  'LastName',
  'MiddleName',
  'OwnershipFormDescription',
  'OwnershipFormRef',
  'Ref',
];

export const recipientRefSearchResultKeys = senderRefSearchResultKeys;

export enum AnalyticsLabels {
  InternetDocument = 'Інтернет Документ',
  InRegister = 'В реєстрі',
  NotInRegister = 'Не в реєстрі',
  Printed = 'Роздруковані',
  NotPrinted = 'Не роздруковані',
  InfoRegClientBarcodes = 'Внутрішній номер',
  WeightFrom = 'Вага від',
  WeightTo = 'Вага до',
  WeightFromAndTo = 'Вага від та до',
  SeatsAmountFrom = 'Місць від',
  SeatsAmountTo = 'Місць до',
  SeatsAmountFromAndTo = 'Місць від та до',
  CreationDateTimeFrom = 'Створили з',
  CreationDateTimeTo = 'Створили по',
  CreationDateTimeFromAndTo = 'Створили з та по',
  DateTimeFrom = 'Відправлять з',
  DateTimeTo = 'Відправлять по',
  DateTimeFromAndTo = 'Відправлять з та по',
  DeliveryDateTimeFrom = 'Планово доставлять з',
  DeliveryDateTimeTo = 'Планово доставлять по',
  DeliveryDateTimeFromAndTo = 'Планово доставлять з та по',
  PreferredDeliveryDate = 'Бажана дата доставки',
  CostFrom = 'Оголошена цінність від',
  CostTo = 'Оголошена цінність до',
  CostFromAndTo = 'Оголошена цінність від та до',
  WithMoneyTransfer = 'З післяплатою',
  NotWithMoneyTransfer = 'Без післяплати',
  WithPaymentControl = 'З контролем оплати',
  NotWithPaymentControl = 'Без контролем оплати',
  CostOnSiteFrom = 'Ціна доставки від',
  CostOnSiteTo = 'Ціна доставки до',
  CostOnSiteFromAndTo = 'Ціна доставки від та до',
  PayerType = 'Платник за доставку ',
  SelectPaymentOnSitePayed = 'Статус оплати доставки сплачено',
  SelectPaymentOnSiteNotPayed = 'Статус оплати доставки не сплачено',
  SenderRef = 'Відправник',
  SenderContactPerson = 'Контакт відправника',
  SenderContactPhone = 'Телефон відправника',
  SenderCity = 'Місто відправлення',
  DeliveryFrom = 'Місце відправлення ',
  SenderWarehouse = 'Доставка з',
  RecipientRef = 'Отримувач',
  RecipientEDRPOU = 'ЄДРПОУ отримувача',
  RecipientContactPhone = 'Телефон отримувача',
  RecipientCity = 'Місто отримання',
  RecipientWarehouse = 'Доставка до',
  BackwardDeliveryDocuments = 'Зворотна доставка документів',
  Packing = 'Замовлено пакування',
  FloorsLifting = 'До дверей',
  SameDayDelivery = 'Локал Експрес',
  SubtypeDocuments = 'Зворотна доставка підтипів документів',
  SignedDocuments = 'Зворотна доставка підписаних документів',
  Forwarding = 'Контроль поштучної передачі',
  DeliveryFromAddress = 'Адреса відправника',
  DeliveryFromWarehouse = 'Відділення відправника',
  DeliveryFromPostomat = 'Поштомат відправника',
  DeliveryToAddress = 'Адреса отримувача',
  DeliveryToWarehouse = 'Відділення отримувача',
  DeliveryToPostomat = 'Поштомат отримувача',
}
